import React from 'react';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { useDispatch } from 'react-redux';
import { usePagination } from '../../pages/arc/shared-slices/usePagination';
import { goToPage } from '../../pages/arc/shared-slices/pagination-slice';
import { paginationStyles } from '../../global/constants/theme/styles/components/pagination';
import { buttonStyles } from '../../global/constants/theme/styles/components/buttonstyles';


interface ListPaginationProps {
	name: string,
	totalPages: number,
	nextButton: string,
	prevButton: string,
	totalCounts: number,
}

export const ListPagination = (props: ListPaginationProps) => {
	const dispatch = useDispatch();	

	const pagination = usePagination(props.name, props.totalPages, 1);
	const classes = paginationStyles();
	const buttonClasses = buttonStyles();
	
	if (!pagination) {
		return null;
	}

	const next = () => {
		dispatch(goToPage(pagination.currentPage + 1, pagination.name));
	};

	const prev = () => {
		dispatch(goToPage(pagination.currentPage - 1, pagination.name));
	};

	const hidePagination = pagination.lastPage <= 1;

	const getBeginCount = (page: number) => {
		return page * 10 - 9;
	};

	const getEndCount = (page: number, totalCount) => {
		return page * 10 > totalCount ? totalCount : page * 10;
	};

	if (props.totalCounts < 10) {
		return null;
	}
	return (
		<>
			{
				!hidePagination ?
					<div className={`${classes.paginationContainer} table-pagination`}>
						<div className='pagination-inner'>
							<button type='button' className={buttonClasses.secondaryButton} disabled={pagination.currentPage === pagination.firstPage} onClick={prev}>
								<ArrowBackIosIcon /> {props.prevButton}
							</button>							

							<div className='pagination-text'>
								{`${getBeginCount(pagination.currentPage)}-${getEndCount(pagination.currentPage, props.totalCounts)} of ${props.totalCounts}`}
							</div>							

							<button type='button' className={`${buttonClasses.secondaryButton} ${buttonClasses.iconButtonRight}`} disabled={pagination.currentPage === pagination.lastPage} onClick={next}>
								{props.nextButton} <ArrowForwardIosIcon />
							</button>
						</div>
					</div>
					: null
			}
		</>
	);
};
